import { Link } from "react-router-dom"
import { LogOut } from "lucide-react"
import { logout } from "@/redux/actions/sessionAction"
import { useDispatch } from "react-redux"
import { config } from "@/config"
export default function LogoutLink() {
    const dispatch = useDispatch()

    function onClick() {
        dispatch(logout())
        localStorage.clear()
    }

    return (
        <div className="p-4">
            <Link
                onClick={onClick}
                to="/login"
                className="flex items-center p-3 hover:bg-gray-200 rounded-lg transition-colors duration-200"
            >
                <LogOut className="w-5 h-5 mr-4 text-blue-400" />
                <span className="font-medium text-gray-500">Logout</span>
            </Link>
        </div>
    )
}
